import { render, staticRenderFns } from "./TableConfig.vue?vue&type=template&id=33f878a8&scoped=true&"
import script from "./TableConfig.vue?vue&type=script&lang=js&"
export * from "./TableConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f878a8",
  null
  
)

export default component.exports